var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.09,
    height: 122.09,
    viewBox: "0 0 122.09 122.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(-11756.689 2663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M803.156,169.91a61.045,61.045,0,1,1-61.045,61.045h0A61.045,61.045,0,0,1,803.156,169.91Z",
    transform: "translate(11014.578 -2832.91)",
    fill: "#595a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M852.539,238.1a8.355,8.355,0,0,0-5.9-5.9,244.4,244.4,0,0,0-52.136,0,8.355,8.355,0,0,0-5.9,5.9,93.214,93.214,0,0,0,0,32.119,8.359,8.359,0,0,0,5.9,5.9,244.4,244.4,0,0,0,52.136,0,8.355,8.355,0,0,0,5.9-5.9A93.184,93.184,0,0,0,852.539,238.1Zm-42.318,29.747V240.463l24.7,13.689Z",
    transform: "translate(10996.982 -2856.664)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b5c92948616a41a553e3b6541d559d50.svg";
export { ForwardRef as ReactComponent };